// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  FILE_PATH: '',
  API_BASE_URL: 'https://aoc-backend.seaswap.co/api/v1/admin',
  SUPPORTED_CHAINS: ['0x61'],
  // The chain this environment must operate on. The wallet is switched to it
  // automatically when the admin signs in.
  REQUIRED_CHAIN: '0x61',
  BSC_TRANSACTION_HASH_BASEURL: 'https://testnet.bscscan.com/tx/',
  TRON_TRANSACTION_HASH_BASEURL: 'https://tronscan.org/#/transaction/',
  ETH_TRANSACTION_HASH_BASEURL: 'https://etherscan.io/tx/',
  '0x61': {
    EXPLORER: 'https://testnet.bscscan.com/',
    PROVIDER: 'https://data-seed-prebsc-2-s3.binance.org:8545',
    CHAIN_NETWORK: '0x61',
    CHAINID: 97,
    CURRENCY_NAME: 'BNB',
    CURRENCY_SYMBOL: 'BNB',
    NETWORK_SYMBOL: 'BSC',
    CHAIN_NAME: 'BSC TESTNET',
    CROWD_SALE: "0x415896CC81917AEd67A48a74F2816D8E7eF5f032"
  },
  FILE_UPLOAD_URL: 'https://aoc-backend.seaswap.co/api/v1/file-upload/upload',
  SOCKET_URL: 'https://aoc-backend.seaswap.co',
  // Request-log device tracking: the device register call and the x-device-* headers.
  // Off until the backend register route is live in this environment.
  DEVICE_TRACKING_ENABLED: false,
  // Which deployment this bundle is for. The Member Type Change "Shift to AMC Window" button
  // shows only on 'development' and 'staging', with that environment's instructions.
  ENVIRONMENT_NAME: 'development',
  // Ships in the public bundle: restrict the key to the admin domains in the Infura dashboard.
  INFURA_API_KEY: '49709bb81fa74b15a224e25af168c1ce'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
